import type { FieldValues, Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { Input } from '../Input';
import type { InputProps } from '../types';

interface FormInputProps<T extends FieldValues> extends InputProps<T> {
  name: Path<T>;
}

export const FormInput = <T extends FieldValues>({ name, ...rest }: FormInputProps<T>) => {
  const { setValue, clearErrors } = useFormContext<T>();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value as FieldValues[Path<T>];
    setValue(name as Path<T>, value);
    rest.onChange?.(e);
    clearErrors(name as Path<T>);
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const value = e.target.value as FieldValues[Path<T>];
    rest.onBlur?.(e);

    setValue(name as Path<T>, value, { shouldDirty: true, shouldValidate: true, shouldTouch: true });
  };

  return <Input name={name} {...rest} onChange={handleChange} onBlur={handleBlur} />;
};
